import '../../css/sidebar_header.css';
import Header from '../Header/Header';
import SettingsTabs from './SettingsTabs';
import { useSelector } from 'react-redux';
import pmsConstants from '../../pmsConstants';

export default function SettingsPage() {
    const loginDetails = useSelector(state => state.loginDetails);
    
    // Check if user is staff - if so, don't show sidebar
    const isStaffUser = loginDetails?.loggedInUser?.user_type === pmsConstants.USER_TYPE_STAFF;
    
    return (
        <div className="min-h-screen bg-[#edeef2]">
            <Header />
            <main
                className={`
                    pt-[70px]
                    transition-all duration-300
                    ${isStaffUser ? "" : "md:ml-72"}
                `}
            >
                <div className="p-4 sm:p-6">
                    <div className="ml-8">
                        <div className="top-[20px] z-30 bg-[#edeef2]">
                            <div className="flex items-center justify-between py-4 px-4 sm:px-6">
                                <h1 className="text-base sm:text-xl font-bold text-gray-800">Settings</h1>
                            </div>
                        </div>

                        <div className="bg-white rounded-lg">
                            <SettingsTabs />
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}